"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _getCSRFHeader = _interopRequireDefault(require("./getCSRFHeader"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = _getCSRFHeader["default"];
exports["default"] = _default;